const HERO_OVERLAY = 'linear-gradient(90deg, rgba(10,10,9,.98) 0%, rgba(10,10,9,.90) 38%, rgba(10,10,9,.25) 72%, rgba(10,10,9,.08) 100%)';

export const HERO_BG_STYLE = {
  backgroundImage: `${HERO_OVERLAY}, url(/images/hero-bg.jpg)`,
};

export const heroStyle = (img) => ({
  backgroundImage: `${HERO_OVERLAY}, url(${img})`,
});

export const HERO_CENNIK = heroStyle('/images/01_CENNIK_banner.jpg');
export const HERO_BLOG = heroStyle('/images/03_BLOG_banner.jpg');
export const HERO_FAQ = heroStyle('/images/02_FAQ_banner.jpg');
export const HERO_KONTAKT = heroStyle('/images/04_KONTAKT_banner.jpg');
